import { render, staticRenderFns } from "./MantenimientoCorrectivoForm.vue?vue&type=template&id=31b82fea&scoped=true&"
import script from "./MantenimientoCorrectivoForm.vue?vue&type=script&lang=ts&"
export * from "./MantenimientoCorrectivoForm.vue?vue&type=script&lang=ts&"
import style0 from "./MantenimientoCorrectivoForm.vue?vue&type=style&index=0&id=31b82fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b82fea",
  null
  
)

export default component.exports